import {
  Component,
  AfterViewInit,
  OnInit,
  LOCALE_ID,
  Inject,
} from "@angular/core";
import { PedidoServiceService } from "../account/pedidos/services/pedido-service.service";
import { Router, ActivatedRoute } from "@angular/router";
import { registerLocaleData } from "@angular/common";
import localeEs from "@angular/common/locales/es";
import { switchMap } from "rxjs/operators";

@Component({
  selector: "app-estatus-orden",
  templateUrl: "./estatus-orden.component.html",
  styleUrls: ["./estatus-orden.component.scss"],
  providers: [{ provide: LOCALE_ID, useValue: "es" }],
})
export class EstatusOrdenComponent {
  // public estatusOrden: string = 'Entregado';
  public statusPendiente: boolean = false;
  public estatusTransito: boolean = false;
  public estatusEnRuta: boolean = false;
  public estatusEntregado: boolean = false;
  public statusCancel: boolean = false;
  public idOrden: number;
  public limiteFactura: string; 
  public arraySeguimiento: Array<any> = [];
  // public orden: ProductoOrden;
  public orden: any;
  public disabledFact: boolean = true;
  constructor(
    private pedidoService: PedidoServiceService,
    private router: Router,
    private route: ActivatedRoute,
    @Inject(LOCALE_ID) private locale: string
  ) {
    registerLocaleData(localeEs, locale);
  }

  ngOnInit() {
    this.route.params.subscribe((param) => {
      const id = param["id"];
      this.obtenerOrden(id);
    });
  }
  // fakeOrder = {
  //   idOrden: 378,
  //   orden: [
  //     {
  //       id: 107,
  //       numeroOrden: "378-20231213-121511",
  //       estatus: 0,
  //       estatusNombre: null,
  //       entregaEstimada: "2023-12-20T00:00:00",
  //       noGuia: "HM1606229981666NHN",
  //       carrier: "ESTAFETA",
  //       seguimiento: [
  //         {
  //           fechaHora: "2023-12-13T12:33:53.34",
  //           id: 137,
  //           idEnvio: 107,
  //           estatus: 2,
  //           estatusNombre: "En ruta a recolección",
  //           entregaEstimada: "2023-12-20T00:00:00",
  //           noGuia: "HM1606229981666NHN",
  //           carrier: "ESTAFETA",
  //           estatusDetail: "En ruta a recolección",
  //           traker: "HM1606229981666NHN",
  //         },
  //         {
  //           fechaHora: "2023-12-13T12:15:12.76",
  //           id: 136,
  //           idEnvio: 107,
  //           estatus: 1,
  //           estatusNombre: "Pendiente de recolección",
  //           entregaEstimada: "2023-12-20T00:00:00",
  //           noGuia: "HM1606229981666NHN",
  //           carrier: "ESTAFETA",
  //           estatusDetail: null,
  //           traker: "HM1606229981666NHN",
  //         },
  //       ],
  //       estatusDetail: null,
  //       tracker: "HM1606229981666NHN",
  //     },
  //   ],this.router.navigateByUrl('/pages/login')
  // };
  obtenerOrden(id: number) {
    this.pedidoService.rastrearPedido(id).subscribe((orden) => {
      this.orden = orden;
const hoy = new Date();
     /* this.orden =
      {
    "idOrden": 215,
    "orden": [
        {
            "id": 10815,
            "numeroOrden": "215-2025829-163538",
            "estatus": 0,
            "estatusNombre": null,
            "entregaEstimada": "2025-08-30T00:00:00",
            "noGuia": "1902203579472",
            "carrier": "Paquete Express",
            "seguimiento": [
                {
                    "fecha": "2025-09-01",
                    "hora": "08:43:00",
                    "evento": {
                        "codigoEvento": "PU",
                        "descripcion": "Enviado"
                    },
                    "firmadoPor": null
                },
                {
                    "fecha": "2025-09-01",
                    "hora": "08:43:00",
                    "evento": {
                        "codigoEvento": "PL",
                        "descripcion": "Mercancía en tránsito"
                    },
                    "firmadoPor": null
                },
                {
                    "fecha": "2025-09-02",
                    "hora": "10:43:00",
                    "evento": {
                        "codigoEvento": "AF",
                        "descripcion": "Recibido en sucursal"
                    },
                    "firmadoPor": null
                },
                {
                    "fecha": "2025-09-02",
                    "hora": "11:39:00",
                    "evento": {
                        "codigoEvento": "WC",
                        "descripcion": "En ruta de entrega"
                    },
                    "firmadoPor": null
                }
            ],
            "estatusDetail": null,
            "tracker": null,
            "esFulfil": true
        }
    ]
}
*/
    
      // this.orden.orden[0].seguimiento = [
      //   {
      //      "fecha": "2023-09-19",
      //      "hora": "14:42:00",
      //      "evento": {
      //         "codigoEvento": "PL",
      //         "descripcion": "Shipment picked up"
      //      },
      //      "firmadoPor": null
      //   },
        /*{
           "fecha": "2023-09-19",
           "hora": "19:30:00",
           "evento": {
              "codigoEvento": "AF",
              "descripcion": "Arrived at DHL Sort Facility  CIUDAD JUAREZ-MEXICO"
           },
           "firmadoPor": null
        },
        {
           "fecha": "2023-09-19",
           "hora": "19:33:00",
           "evento": {
              "codigoEvento": "PL",
              "descripcion": "Processed at CIUDAD JUAREZ-MEXICO"
           },
           "firmadoPor": null
        },
        {
           "fecha": "2023-09-19",
           "hora": "19:35:00",
           "evento": {
              "codigoEvento": "DF",
              "descripcion": "Shipment has departed from a DHL facility CIUDAD JUAREZ-MEXICO"
           },
           "firmadoPor": null
        },
        {
           "fecha": "2023-09-20",
           "hora": "00:47:00",
           "evento": {
              "codigoEvento": "AF",
              "descripcion": "Arrived at DHL Sort Facility  QUERETARO-MEXICO"
           },
           "firmadoPor": null
        },
        {
           "fecha": "2023-09-20",
           "hora": "02:29:00",
           "evento": {
              "codigoEvento": "PL",
              "descripcion": "Processed at QUERETARO-MEXICO"
           },
           "firmadoPor": null
        },
        {
           "fecha": "2023-09-20",
           "hora": "02:30:00",
           "evento": {
              "codigoEvento": "DF",
              "descripcion": "Shipment has departed from a DHL facility QUERETARO-MEXICO"
           },
           "firmadoPor": null
        },
        {
           "fecha": "2023-09-20",
           "hora": "05:14:00",
           "evento": {
              "codigoEvento": "AF",
              "descripcion": "Arrived at DHL Sort Facility  MEXICO CITY HUB-MEXICO"
           },
           "firmadoPor": null
        },
        {
           "fecha": "2023-09-20",
           "hora": "06:08:00",
           "evento": {
              "codigoEvento": "PL",
              "descripcion": "Processed at MEXICO CITY HUB-MEXICO"
           },
           "firmadoPor": null
        },
        {
           "fecha": "2023-09-20",
           "hora": "06:36:00",
           "evento": {
              "codigoEvento": "DF",
              "descripcion": "Shipment has departed from a DHL facility MEXICO CITY HUB-MEXICO"
           },
           "firmadoPor": null
        },
        {
           "fecha": "2023-09-20",
           "hora": "07:47:00",
           "evento": {
              "codigoEvento": "AR",
              "descripcion": "Arrived at DHL Delivery Facility  MEXICO CITY-MEXICO"
           },
           "firmadoPor": null
        },
        {
           "fecha": "2023-09-20",
           "hora": "09:24:00",
           "evento": {
              "codigoEvento": "WC",
              "descripcion": "Shipment is out with courier for delivery"
           },
           "firmadoPor": null
        },
        {
           "fecha": "2023-09-20",
           "hora": "14:26:00",
           "evento": {
              "codigoEvento": "OK",
              "descripcion": "Delivered"
           },
           "firmadoPor": "Carlos vigil"
        }*/
   //   ]

     this.orden.orden[0].seguimiento.forEach(item => {
      const fechaLimite = this.calcFechaLimiteFact(item.fecha, item.hora);
      // Agregar fecha límite al objeto, si es necesario:
      item.fechaFormat = fechaLimite;
    });

      this.arraySeguimiento = this.orden.orden[0].seguimiento.filter(
         item => ['OK', 'WC', 'PU', 'PL'].includes(item.evento.codigoEvento))
         .sort((a,b) => {
            const fechaHoraA = new Date(`${a.fecha}T${a.hora}`).getTime();
            const fechaHoraB = new Date(`${b.fecha}T${b.hora}`).getTime();
            return fechaHoraB - fechaHoraA;
         });
         
      // this.orden.orden[0].seguimiento[0].estatus = 5;
      if(this.orden.orden[0].seguimiento[0].estatus === 5) {
        this.limiteFactura = this.calcFechaLimiteFact(this.orden.orden[0].seguimiento[0].fecha, this.orden.orden[0].seguimiento[0].hora);
        this.disabledFact = false;
      } else {
        this.disabledFact = true;
      }

    });     

  }

  obtenerNombreMes(idMes: number) {
    const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    return meses[idMes];
  }

  calcFechaLimiteFact(fecha: string, hora: string) {
    // Combinar fecha y hora
    console.log(fecha, hora);
    const [anio, mes, dia] = fecha.split('-').map(Number);
    const [horas, minutos, segundos] = hora.split(':').map(Number);
  
    // Crear un objeto Date con la fecha y hora proporcionadas
    const fechaEntrega = new Date(anio, mes - 1, dia, horas, minutos, segundos);
  
    // Sumar 30 días
    fechaEntrega.setDate(fechaEntrega.getDate() + 30);
      console.log(fechaEntrega)
    // Formatear la fecha
    const anioResultado = fechaEntrega.getFullYear();
    const mesResultado = this.obtenerNombreMes(fechaEntrega.getMonth());
    const diaResultado = fechaEntrega.getDate().toString().padStart(2, '0');
    
    // Devolver la fecha formateada
    return `${diaResultado} de ${mesResultado} de ${anioResultado}`;
  }
  
  
  generarFact(orderId: number) {
    this.router.navigateByUrl("/pages/agregar-datos-facturacion");
  }

  volver() {
    this.router.navigateByUrl("/pages/pedidos");
  }
}
